import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const TwitterDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.tw1-1_svg__cls-1{fill:#fff}.tw1-1_svg__cls-2{fill:#eee}.tw1-1_svg__cls-3{fill:none;stroke:#f5f5f5;stroke-miterlimit:10}.tw1-1_svg__cls-4{fill:#9e9e9e}.tw1-1_svg__cls-5{fill:#1ba1f4}.tw1-1_svg__cls-6{fill:#424242}'
        }
      </style>
    </defs>
    <g id="tw1-1_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="tw1-1_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="tw1-1_svg__cls-1"
          d="M6.28 39.65h132.07v21.96H6.28zM138.27 39.65v-18A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v18z"
        />
        <path className="tw1-1_svg__cls-2" d="M26.67 50.01h21.38v3.94H26.67zM26.68 44h34.36v4.21H26.68z" />
        <path
          className="tw1-1_svg__cls-1"
          d="M6.28 60.24v219a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31v-219z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path
          className="tw1-1_svg__cls-2"
          d="M11.65 64.92h122.61v4.21H11.65zM11.65 85.12h122.61v4.21H11.65zM11.65 74.48h117.91v4.21H11.65z"
        />
        <path className="tw1-1_svg__cls-3" d="M6.46 243h131.65M6.46 36.17h131.65" />
        <circle className="tw1-1_svg__cls-4" cx={129.32} cy={272.22} r={4.77} />
        <circle className="tw1-1_svg__cls-4" cx={92.43} cy={272.22} r={4.77} />
        <circle className="tw1-1_svg__cls-4" cx={53.81} cy={272.22} r={4.77} />
        <circle className="tw1-1_svg__cls-5" cx={16.93} cy={272.22} r={4.77} />
        <circle className="tw1-1_svg__cls-6" cx={16.92} cy={49.87} r={6.55} />
        <circle className="tw1-1_svg__cls-5" cx={67.5} cy={46.81} r={1.73} />
        <path className="tw1-1_svg__cls-2" d="M15.63 218.85h55.23v4.21H15.63zM15.63 226.2h30.11v4.21H15.63z" />
        <rect className="tw1-1_svg__cls-5" x={100.59} y={219.47} width={28.09} height={9.87} rx={2.89} />
        <rect x={13.4} y={249.8} width={116.48} height={11.38} rx={5.69} fill="#e7e7e7" />
        <path d="M132.39 215.27v18.9H12.53v-18.9h119.86m1-1H11.53v20.9h121.86v-20.9z" fill="#f5f5f5" />
        <path className="tw1-1_svg__cls-6" d="M11.53 93.73h121.79v121.79H11.53z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default TwitterDevice11;
